import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class ActivityImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** POST /activity */
  public postActivity(body: {
    address: string;
    transactionHash: string;
    value: number;
    type: API.ActivityType;
    tokenAddress?: string;
    status?: API.ActivityStatus;
    nonce?: number;
    blockTimestamp?: number;
  }) {
    // Hardcoded response: 201 OK
    return this.makeRequest<{ status: string }>(`activity`, { method: 'POST', body });
  }

  /** GET /activity */
  // Before = DateTime in ISO 8601 format. Sort = "asc | desc"
  public getActivity(query?: { address: string; before?: string; sort?: string }) {
    return this.makeRequest<API.ActivityListResponse>(`activity`, {
      method: 'GET',
      query
    });
  }

  /** GET v2/activity/ */
  public getV2Activity(query?: {
    sender: string;
    token: string; // List of token addresses separated by commas.
    limit?: number;
    offset?: number;
    before?: string;
    sort?: string; // "asc" | "desc"
  }) {
    return this.makeRequest<API.ActivityListResponseV2>(`v2/activity`, {
      method: 'GET',
      query
    }) as Promise<API.ActivityListResponseV2>;
  }

  /** GET /v3/activity */
  // same as v2
  public getV3Activity(query?: {
    sender: string;
    token: string;
    limit?: number;
    offset?: number;
    before?: string;
    sort?: string;
  }) {
    return this.makeRequest<API.ActivityListResponseV1>(`v3/activity`, {
      method: 'GET',
      query
    }) as Promise<API.ActivityListResponseV1>;
  }
}
